import React from 'react';

const TableD = (props) => {
  let icon = '';
  if (props.children.every(item => /^yes$/igm.test(item))) {
    icon = String.fromCharCode(10003);
  } else if (props.children.every(item => /^no$/igm.test(item))) {
    icon = String.fromCharCode(10007);
  }
  return (
    <td className="px-3 py-2" {...props}>
      {icon ? icon : props.children}
    </td>
  );
};

export default TableD;
